<template>
    <Section id="clients">
        <template #section>
            {{ $t('budgets_landing_page.clients') }}
        </template>
        <template #title>
            {{ $t('budgets_landing_page.clients_subtitle') }}
        </template>
        <div class="lg:grid-cols-2 gap-x-12 gap-y-6 lg:gap-y-0 grid">
            <div>
                <h3 class="mt-0 mb-2.5 text-xl font-medium">
                    {{ $t('budgets_landing_page.clients_tagline') }}
                </h3>
                <p class="mb-0 text-base font-normal leading-6">
                    {{ $t('budgets_landing_page.clients_paragraph') }}
                </p>
            </div>
            <div class="grid gap-0.5 overflow-hidden rounded-lg grid-cols-2 md:grid-cols-3">
                <div class="inline-flex items-center p-5 bg-gray-200" v-for="client in clients">
                    <img class="max-h-12 object-contain object-center w-full" :src="client.imagePath" :alt="client.name" :title="client.name" />
                </div>
            </div>
        </div>
    </Section>
</template>

<script>
import Section from '../../../../shared/section.vue';

export default {
    components: {
        Section,
    },

    computed: {
        clients() {
            const clients = [
                {
                    name: 'WebDigital',
                    imagePath: '/images/marketing/clients/webdigital.png',
                },
                {
                    name: 'KGMedia',
                    imagePath: '/images/marketing/clients/kg-media.png',
                },
                {
                    name: 'Basta Digital',
                    imagePath: '/images/marketing/clients/basta-digital.png',
                },
                {
                    name: 'Bittnet Training',
                    imagePath: '/images/marketing/clients/bittnet.png',
                },
                {
                    name: 'Neakaisa',
                    imagePath: '/images/marketing/clients/neakaisa.svg',
                },
                {
                    name: 'EVO Horeca',
                    imagePath: '/images/marketing/clients/evo-horeca.png',
                },
            ];

            return clients;
        },
    },
};
</script>
